export default "__VITE_ASSET__3592c64d__"